import { ReactNode } from "react"
import { tv } from "@utils/tw"

export type DropdownButtonItem = {
  type: "item"
  disabled?: boolean
  onSelect?: (e: Event) => void
  textValue?: string
  label?: string | ReactNode
  className?: string
}

export type DropdownCheckboxItem = {
  type: "checkbox"
  checked?: boolean
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
  label?: string | ReactNode
  className?: string
  textValue?: string
}

export type DropdownRadioGroupItemOption = {
  label: string | ReactNode
  value: string
}

export type DropdownRadioGroupItem = {
  type: "radio"
  value?: string
  onValueChange?: (value: string) => void
  label?: string | ReactNode
  disabled?: boolean
  options: {
    label: string | ReactNode
    value: string
    disabled?: boolean
  }[]
}

export type DropdownSubnavItem = {
  type: "subnav"
  label: string | ReactNode
  items: DropdownItem[]
}

export type DropdownSeparatorItem = {
  type: "separator"
}

export type DropdownHeadingItem = {
  type: "heading"
  label: string | ReactNode
}

export type DropdownItem =
  | DropdownButtonItem
  | DropdownCheckboxItem
  | DropdownRadioGroupItem
  | DropdownSubnavItem
  | DropdownSeparatorItem
  | DropdownHeadingItem

export const dropdownMenuStyles = tv({
  slots: {
    content: [
      "z-50",
      "bg-bg border border-blue outline-none text-fg",
      "radix-popover-animation",
      "min-w-[8rem] overflow-auto",
      "p-0",
      "max-h-[calc(var(--radix-popper-available-height)-8px)]",
    ],
    items: "flex flex-col gap-1 md:p-2",
    separator: "h-[1px] bg-bg-mid",
    header: "flex justify-between p-2 pl-4 type-ui-l items-center gap-2 border-b border-bg-low",
  },
})

export const dropdownItemStyles = tv({
  base: "flex items-center text-left outline-none gap-3 px-3 py-2 md:px-1 md:py-1 md:gap-2 data-[disabled]:opacity-50 data-[disabled]:!cursor-default",
  slots: {
    indicator: "flex-none size-icon el-svg:size-icon flex items-center justify-center",
    arrow: "flex-none size-icon el-svg:size-icon flex items-center justify-center",
    label: "flex-1 pr-2",
  },
  variants: {
    selectable: {
      true: {
        base: [
          "cursor-pointer",
          "transition-colors duration-75 data-[highlighted]:duration-0",
          "max-sm:active:bg-bg-mid max-sm:active:duration-0 data-[highlighted]:bg-bg-mid data-[state=checked]:bg-bg-mid data-[highlighted]:text-fg",
        ],
        label: "md:type-ui-m",
      },
    },
    caption: {
      true: {
        base: "text-muted cursor-default",
        label: "type-label-s",
      },
    },
  },
  defaultVariants: {
    selectable: true,
  },
})
